import api from "@modules/AudienceManager/api";

export default {
    namespaced: true,
    state: {
        /**
         * @type {CircleChartNodeBase} Data to use for our circle chart
         */
        circleChartRootNode: undefined
    },
    mutations: {
        /**
         * Set data for our circle chart
         * @param {Object} state Current store state.
         * @param {CircleChartNodeBase} context Root node for our chart
         */
        setCircleChartRootNode(state, context){
            state.circleChartRootNode = context;
        }
    },
    actions: {
        /**
         * Load and expose the circle chart data for the given audience.
         * 
         * @param {function} commit Vuex mutation commit handler.
         * @param {string} audienceId Id of the audience for which to retrieve the data.
         */
        async loadCircleChartData({commit}, audienceId) {
            //Signal node reset
            commit('setCircleChartRootNode', undefined);
            
            const {rootNode} = await api.getAudienceCircleChartData(audienceId);
            commit('setCircleChartRootNode', rootNode);
            
            // return new Promise((resolve, reject) => {
            //     api.getAudienceCircleChartData(audienceId).then(
            //         ({rootNode}) => {
            //             commit('setCircleChartRootNode', rootNode);
            //             resolve();
            //         },
            //         err => reject(err)
            //     )
            // });
        },
        
        /**
         * Reset the store to an empty state, this is necessary to prevent hogging memory upon leaving the module
         */
        cleanup({commit, state}){
            //TODO: Implement
            //Call when navigating away from module
            //Invoke mutations cleaning state not needed by other modules
            //this to prevent memory leaks from taking place 

            //https://tahazsh.com/vuebyte-reset-module-state
            //https://stackoverflow.com/questions/42295340/how-to-clear-state-in-vuex-store
        }
    }
};